import * as z from "zod";
import { isoDate } from "./common";

export const USER_ROLES = ["USER", "ADMIN"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const UserProfile = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  emailVerified: z.boolean(),
  /** Platform staff flag, not a merchant permission. */
  role: z.enum(USER_ROLES),
  image: z.string().nullable().default(null),
  createdAt: isoDate,
  updatedAt: isoDate,
});
export type UserProfile = z.output<typeof UserProfile>;

/** A platform admin, as the back-office's Admins page lists them. */
export const PlatformAdmin = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  createdAt: isoDate,
  /** The caller, who may not remove themselves. */
  isSelf: z.boolean(),
});
export type PlatformAdmin = z.output<typeof PlatformAdmin>;
